import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { Field } from 'redux-form';

import Message from 'components/Message';
import { Form, Button } from 'components/Form';
import RenderTextField from 'components/RenderTextField';

import './ReplyToReviewForm.scss';

const COMMUNITY_GUIDELINES_LINK = 'https://classpass.com/about/community-standards';

const messages = defineMessages({
  cancel: {
    id: 'ratings.reply-to-review.cancel',
    defaultMessage: 'Cancel',
  },
  replyInputPlaceholder: {
    id: 'ratings.reply-to-review.reply-input-placeholder',
    defaultMessage:
      'E.g.: Thanks for the feedback! Our staff strive to make every experience the best experience. Hope to see you soon!',
  },
  submit: {
    id: 'ratings.reply-to-review.submit',
    defaultMessage: 'Post reply',
  },
  visibilityDisclaimerText: {
    id: 'ratings.reply-to-review.visibility-disclaimer.text',
    defaultMessage:
      'Your response will be shown publicly to all ClassPass members next to this review. For more information about our content policy, <a>read our guidelines.</a>',
  },
});

const ReplyToReviewForm = ({ onCancelClick }) => (
  <>
    <p className="reply-to-review-form__small_text">
      <Message
        message={messages.visibilityDisclaimerText}
        values={{
          a: text => (
            <a href={COMMUNITY_GUIDELINES_LINK} rel="noopener noreferrer" target="_blank">
              {text}
            </a>
          ),
        }}
      />
    </p>
    <Form>
      <Field
        type="text"
        name="response"
        placeholder={messages.replyInputPlaceholder}
        component={RenderTextField}
        autoFocus
      />
      <div className="reply-to-review-form__submit-row">
        <div>
          <Message
            as={Button}
            styled="tertiary"
            className="reply-to-review-form__button bt--sm bt--text-sm"
            onClick={onCancelClick}
            message={messages.cancel}
          />
        </div>

        <div>
          <Message
            as={Button}
            styled="primary"
            className="reply-to-review-form__button bt--sm bt--text-sm"
            data-cypress="reply-to-review-submit-button"
            type={Button.TYPES.SUBMIT}
            message={messages.submit}
          />
        </div>
      </div>
    </Form>
  </>
);

ReplyToReviewForm.propTypes = {
  onCancelClick: PropTypes.func,
};

export default ReplyToReviewForm;
